import React from 'react';
import "./Axios/AxiosInterceptor";
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import BaseApp from './Scenes/BaseApp';

function App() {
  return (
    <BrowserRouter>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#479BFF',
            //borderRadius:0,

          },
        }}
      >
        <BaseApp />
      </ConfigProvider>
    </BrowserRouter>
  );
}

export default App;
